import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { THDSAngularAuthService } from '@thds/auth/angular';
import { DlButtonModule } from '@thds/components/button';
import { DlPaginator, DlPaginatorModule } from '@thds/components/paginator';
import { DlSearchBarModule } from '@thds/components/search-bar';
import { DlSort, DlSortModule } from '@thds/components/sort';
import { DlDataSource, DlTableModule } from '@thds/components/table';
import { AggregierteAuswertungLayoutDto } from '../../api/models';

@Component({
  selector: 'thds-aggregierteauswertungen-layouts-list',
  standalone: true,
  imports: [
    CommonModule,
    DlTableModule,
    DlPaginatorModule,
    DlSearchBarModule,
    DlSortModule,
    ReactiveFormsModule,
    DlButtonModule,
    RouterLink,
  ],
  templateUrl: './aggregierteauswertungen-layouts-list.component.html',
  styleUrls: ['./aggregierteauswertungen-layouts-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AggregierteAuswertungenLayoutsListComponent
  implements AfterViewInit, OnInit
{
  private readonly _authService = inject(THDSAngularAuthService);
  @ViewChild(DlPaginator) paginator!: DlPaginator;
  @ViewChild(DlSort) sort!: DlSort;

  @Input()
  public selectedLayoutId: string | undefined;
  public readonly filterControl = new FormControl<string>('');
  public readonly columns = ['name', 'kuerzel'];
  tableData = new DlDataSource<AggregierteAuswertungLayoutDto>([]);
  @Input()
  public readonly allowCreation = true;
  @Output()
  create = new EventEmitter<void>();
  @Output()
  selectLayout = new EventEmitter<AggregierteAuswertungLayoutDto>();

  @Input({ required: true })
  public set aggregierteAuswertungenLayouts(
    layouts: AggregierteAuswertungLayoutDto[],
  ) {
    this.tableData.data = layouts;
    this.tableData._updateChangeSubscription();
  }

  public onLayoutClick(layout: AggregierteAuswertungLayoutDto) {
    this.selectLayout.emit(layout);
  }

  ngAfterViewInit(): void {
    this.tableData.paginator = this.paginator;
    this.tableData.sort = this.sort;
  }

  ngOnInit(): void {
    this.tableData.filterPredicate = (data, filter) => {
      return (
        data.name.toLowerCase().includes(filter.toLowerCase()) ||
        data.kuerzel.toLowerCase().includes(filter.toLowerCase())
      );
    };
    this.filterControl.valueChanges.subscribe((value) => {
      this.tableData.filter = value ?? '';
    });
  }

  hasScope(scope: string) {
    return this._authService.userScopes.includes(scope);
  }
}
